import React from 'react'
import style from './Titlebar.module.css'

const Titlebar = () => {
    return (
        <div className={style.titlebar}>
        </div>
    )
}

export default Titlebar